export default __webpack_public_path__ + "static/media/SX.b7626ced.svg";